import type { FilterModel } from "ag-grid-community";
import { parseDateToISO } from "widgets";

export const transformFilter = (filterModel: FilterModel | null) => {
  if (!filterModel) return {};
  return Object.entries(filterModel).reduce((acc, [field, filter]) => {
    // Edit dates columns filtering (converts AG-grid dates to ISO 8601 dates)
    if (filter.dateFrom) {
      // @ts-expect-error Wait MT fix openapi types
      acc[field] = {
        ...filter,
        dateFrom: filter.dateFrom ? parseDateToISO(filter.dateFrom) : undefined,
        dateTo: filter.dateTo ? parseDateToISO(filter.dateTo) : undefined,
      };
    }
    // Add other "else if" in case of other custom filters
    else {
      // @ts-expect-error Wait MT fix openapi types
      acc[field] = filter;
    }
    return acc;
  }, {});
};
